import { defineMessages } from 'react-intl';

const messages = defineMessages({
  unit: {
    id: 'App.Ledger.LedgerFilterSection.LedgerFilterLayout.Unit',
    defaultMessage: 'Unit',
  },
  transactionDate: {
    id: 'App.Ledger.LedgerFilterSection.LedgerFilterLayout.TransactionDate',
    defaultMessage: 'Transaction Date',
  },
  actualPostDate: {
    id: 'App.Ledger.LedgerFilterSection.LedgerFilterLayout.ActualPostDate',
    defaultMessage: 'Actual Post Date',
  },
  subjournal: {
    id: 'App.Ledger.LedgerFilterSection.LedgerFilterLayout.Subjournal',
    defaultMessage: 'Subj',
  },
  period: {
    id: 'App.Ledger.LedgerFilterSection.LedgerFilterLayout.Period',
    defaultMessage: 'Period',
  },
  code: {
    id: 'App.Ledger.LedgerFilterSection.LedgerFilterLayout.Code',
    defaultMessage: 'Code',
  },
  status: {
    id: 'App.Ledger.LedgerFilterSection.LedgerFilterLayout.Status',
    defaultMessage: 'St*',
  },
  manual: {
    id: 'App.Ledger.LedgerFilterSection.LedgerFilterLayout.Manual',
    defaultMessage: 'M**',
  },
  transactionNotes: {
    id: 'App.Ledger.LedgerFilterSection.LedgerFilterLayout.TransactionNotes',
    defaultMessage: 'Transaction Notes',
  },
  description: {
    id: 'App.Ledger.LedgerFilterSection.LedgerFilterLayout.Description',
    defaultMessage: 'Description',
  },
  documentNumber: {
    id: 'App.Ledger.LedgerFilterSection.LedgerFilterLayout.DocumentNumber',
    defaultMessage: 'Doc #',
  },
  charges: {
    id: 'App.Ledger.LedgerFilterSection.LedgerFilterLayout.Charges',
    defaultMessage: 'Charges',
  },
  credits: {
    id: 'App.Ledger.LedgerFilterSection.LedgerFilterLayout.Credits',
    defaultMessage: 'Credits',
  },
  balance: {
    id: 'App.Ledger.LedgerFilterSection.LedgerFilterLayout.Balance',
    defaultMessage: 'Balance',
  },
  view: {
    id: 'App.Ledger.LedgerFilterSection.LedgerFilterLayout.View',
    defaultMessage: 'View',
  },
  posted: {
    id: 'App.Ledger.LedgerFilterSection.LedgerFilterLayout.Posted',
    defaultMessage: 'P',
  },
  reversed: {
    id: 'App.Ledger.LedgerFilterSection.LedgerFilterLayout.Reversed',
    defaultMessage: 'RD',
  },
  reversal: {
    id: 'App.Ledger.LedgerFilterSection.LedgerFilterLayout.Reversal',
    defaultMessage: 'RL',
  },
});

export default messages;
